export enum RequestAuthorizationDispatchTypes {
    REQUEST_AUTHORIZATION_INVOKE = "REQUEST_AUTHORIZATION_INVOKE",
    REQUEST_AUTHORIZATION_RESET = "REQUEST_AUTHORIZATION_RESET",
    REQUEST_AUTHORIZATION_SUCCESS = "REQUEST_AUTHORIZATION_SUCCESS",
    REQUEST_AUTHORIZATION_ERROR = "REQUEST_AUTHORIZATION_ERROR",
  }